import infoGreen from 'assets/images/account-page/info-green.svg';
import classNames from "classnames";
import React, { useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import PurchaseSavesAndExportsPopup from "../modals/PurchaseSavesAndExports";
import css from "../style.scss";
import { selectUserId , selectUsageSection, selectListManagementEnabled} from "data/user/selectors";
import { useEffect } from 'react';
import { isLegacyAccountPlan, selectPlanDetails } from '../../../data/user';
import ActivateSubscriptionPopup from '../modals/ActivateSubscription';
import TrialIcon from 'assets/images/trialInfo.svg';
import numberFormat from 'utils/number/format';

const UsageSection = props => {
  const userID = useSelector(selectUserId)
  const usageSectionDetails = useSelector(selectUsageSection)
  const listManagementEnabled  = useSelector(selectListManagementEnabled)
  const dispatch = useDispatch();
  const planDetails = useSelector(selectPlanDetails)?.toJS();
  const isLegacyAccount = useSelector(isLegacyAccountPlan);
  const { isFullAccount } = props

  const displayedSkipTracesUsed = Math.min(
    Number(usageSectionDetails?.skipTracesUsed || 0),
    Number(usageSectionDetails?.skipTracesLimit || 0)
  );

  const displayedSkipTracesPercentage = Math.min(
    Number(usageSectionDetails?.skipTracesPercentage || 0),
    100
  );

  const purchaseSavesAndExportsPopup = () => {
    props.purchaseSavesAndExportsPopup(usageSectionDetails)
  }

  // State to track if the popup is open
  const [isSavesRemainingPopupOpen, setSavesRemainingPopupOpen] = useState(false);


  // Function to toggle the popup state
  const savesRemainingPopup = () => {
    setSavesRemainingPopupOpen((prev) => !prev); // Toggles between true and false
  };

  
    useEffect(() => {
      return () => {
        props.purchaseSavesAndExportsPopupClose()
        props.activateSubscriptionPopupClose()
      }
    }, [dispatch,userID])


  const IncreaseLimits = () => {
    return (
      <a
        href="javascript:;"
        className={classNames(css.clsCardTxt, css.text_danger)}
        onClick={purchaseSavesAndExportsPopup}
      >
        Increase Limits
      </a>
    );
  };

  // const RenderContent = () => {
  //   if (isFullAccount && usageSectionDetails?.spendLimit) {
  //     return (
  //       <>
  //         <SpendRemaing />
  //       </>
  //     );
  //   }
  // };
  // const renderContentHasValue = RenderContent();
  const SpendRemaing = () => {
    return (
      <li>
        <div className={css.clsUsageContent}>
          <CircularProgress
            percentage={100 - usageSectionDetails?.spendUsedPercent}
            type="spendremaing"
            className={css.mr_5px}
          />
          <div className={css.clsUsageContentTxt}>
            {/* <h5 className={css.clsUsageContent1}>Spend Remaining</h5> */}

            <div className={css.clsInfoPopup}>
              <h5 className={css.clsUsageContent1}>
                <span>Spend Remaining</span>
                <span className={css.clsInfoIcon} onClick={savesRemainingPopup}><img src={infoGreen} alt="info" /></span>
                <div className={classNames(css.clsInfoPopupContent, {
                  [css.clsOpenPopup]: isSavesRemainingPopupOpen,
                })}>
                  <h5 className={css.clsInfoContentTitle}>Spending Remaining <span className={css.clsCloseIcon} onClick={savesRemainingPopup}>  &times;   </span></h5>
                  <p className={css.clsInfoContentPara}>Use of Prepaid Credits does not count towards this limit. This can be used for any marketing tasks or document purchases. This limit can be changed by the account owner under the Team Member Module in their Account page.</p>
                </div>
              </h5>
            </div>

            <h4 className={css.clsUsageContent2}>${usageSectionDetails?.spendRemaining}</h4>
            <div className={css.clsUsageContent3}>
              <h6>${usageSectionDetails?.spendLimit}</h6>
              <span className={css.clsBorder}></span>
              <h6>{usageSectionDetails?.spendUsedPercent}%</h6>
              <h6>Used</h6>
            </div>
          </div>
        </div>
      </li>
    );
  };

 const FreeSkipTracesRemaining = () => {
    return (
      <li>
        <div className={css.clsUsageContent}>
          <CircularProgress
            percentage={100 - displayedSkipTracesPercentage}
            type="freeskiptraceremaining"
            className={css.mr_5px}
          />
          <div className={css.clsUsageContentTxt}>
            <div className={css.clsInfoPopup}>
              <h5 className={css.clsUsageContent1}>
                <span>Free Skip Traces remaining</span>
              </h5>
            </div>

            <h4 className={css.clsUsageContent2}>{usageSectionDetails?.skipTracesRemaining?.toLocaleString()}</h4>
            <div className={css.clsUsageContent3}>
              <h6>{displayedSkipTracesUsed.toLocaleString()}</h6>
              <span className={css.clsBorder}></span>
              <h6>{displayedSkipTracesPercentage}%</h6>
              <h6>Used</h6>
            </div>
          </div>
        </div>
      </li>
    );
  };


  return (
    <div className={classNames(css.clsCard, css.clsUsageCard)}>
      <div
        className={classNames(
          css.clsCardHeader,
          css.d_flex, css.align_items_center, css.justify_content_between
        )}
      >
        <h4 className={classNames(css.clsCardTitle)}>Usage</h4>
        <div className={css.clsCardTxtGrp}>
          <a href="javascript:;" className={classNames(css.clsCardTxt2)}>
            <span>RESETS IN {usageSectionDetails?.resetsInDays} DAYS</span>
            <span className={css.clsBorder}></span>
            <span>{usageSectionDetails?.resetsOnDate}</span>
          </a>
            {!isFullAccount && !planDetails?.trialAvailable && (
              (Number(usageSectionDetails?.savesUsedPercent) > 80 ||
              Number(usageSectionDetails?.exportsUsedPercent) > 80) && (
                <IncreaseLimits />
              )
            )}
          {planDetails?.trialAvailable && !isLegacyAccount && (
            <a href="javascript:;" className={classNames(css.clsCardTxt, css.text_primary)} 
              onClick={props.activateSubscriptionPopup}
            >
              <span>Activate Subscription</span>
            </a>
          )}
        </div>
      </div>

      <div className={css.clsCardBody}>
        <ul className={classNames(css.clsUsageList, css.unstyled,)}>
          <li
            className={classNames(
              'p-0'
            )}  style={{ minWidth: "225px", height: "72px" }}
          >
            <div className={css.clsUsageContent} style={{ minWidth: "225px", height: "72px" }}>
              <CircularProgress
                percentage={100 - Number(usageSectionDetails?.savesUsedPercent)}
                type="saveremaing"
              />
              <div className={css.clsUsageContentTxt}>
                <div className={css.clsInfoPopup}>
                  <h5 className={css.clsUsageContentFont} style={{ width: "max-content" }}>
                    <span>Saves Remaining </span>
                  </h5>
                </div>

                <h4 className={css.clsUsageContent2}>{usageSectionDetails?.savesRemaining?.toLocaleString()}</h4>
                <div className={css.clsUsageContent3}>
                  <h6>{usageSectionDetails?.savesUsed?.toLocaleString()}</h6>
                  <span className={css.clsBorder}></span>
                  <h6>{Math.round(usageSectionDetails?.savesUsedPercent)}%</h6>
                  <h6>Used</h6>
                </div>
              </div>
            </div>
          </li>
          <li><div className={css.h_line}></div></li>
          <li className={classNames(
              'p-0'
            )}>
            <div className={css.clsUsageContent}>
              <CircularProgress
                percentage={100 - Number(usageSectionDetails?.exportsUsedPercent)}
                type="exportremaining"
              />
              <div className={css.clsUsageContentTxt}>
                <div className={css.clsInfoPopup}>
                  <h5 className={css.clsUsageContentFont}>
                    <span>Exports Remaining</span>
                  </h5>
                </div>
                <h4 className={css.clsUsageContent2}>{usageSectionDetails?.exportsRemaining?.toLocaleString()}</h4>
                <div className={css.clsUsageContent3}>
                  <h6>{usageSectionDetails?.exportsUsed?.toLocaleString()}</h6>
                  <span className={css.clsBorder}></span>
                  <h6>{Math.round(usageSectionDetails?.exportsUsedPercent)}%</h6>
                  <h6>Used</h6>
                </div>
              </div>
            </div>
          </li>
        </ul>
        {planDetails?.trialAvailable && !isLegacyAccount && <div className={css.clsTrialBanner}>
          <div className={css.clsBannerImg}>
            <img src={TrialIcon} alt='banner' />
          </div>
          <div className={css.clsBannerContent}>
            <p className={css.clsBannerPara}>Your account is currently in trial mode. To activate your subscription and gain access to the full {numberFormat(planDetails?.accountEnrolledPlans[0]?.quantity)} property limit, select “Activate Subscription”.</p>
          </div>
        </div>}
      </div>

      {(isFullAccount && usageSectionDetails?.spendLimit)&& (
        <div className={classNames(css.clsCardBody, css.clsBorderTop)}>
          <ul className={classNames(css.clsUsageList, css.unstyled)}>
            {(isFullAccount && usageSectionDetails?.spendLimit)  && (
              <SpendRemaing />
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

const getIconsByType = (type, fillColor) => {
  switch (type) {
    case "saveremaing":
      return (
        <path
          d="M22.4072 21.5541V44.5617C22.4072 45.2628 22.9776 45.8332 23.6787 45.8332C23.9404 45.8332 24.1968 45.7547 24.4113 45.6029L32.4537 39.9727L40.4962 45.6029C40.7107 45.7547 40.9671 45.8332 41.2287 45.8332C41.9299 45.8332 42.5003 45.2628 42.5003 44.5617V21.5541C42.5003 20.1675 41.3753 19.0425 39.9886 19.0425H24.9189C23.5322 19.0425 22.4072 20.1675 22.4072 21.5541Z"
          fill={fillColor}
        />
      );
    case "exportremaining":
      return (
        <>
          <g clipPath="url(#clip0_5551_149595)">
            <path
              d="M22.631 44.9412C18.1938 44.9412 14.5938 41.3412 14.5938 36.904C14.5938 33.3988 16.8375 30.4184 19.9631 29.3188C19.9575 29.1682 19.9519 29.0175 19.9519 28.8668C19.9519 23.9328 23.9482 19.9365 28.8821 19.9365C32.1919 19.9365 35.0775 21.7337 36.6235 24.4128C37.4719 23.8435 38.4989 23.5086 39.5984 23.5086C42.5565 23.5086 44.9565 25.9086 44.9565 28.8668C44.9565 29.5477 44.8282 30.1951 44.5993 30.7979C47.8589 31.4565 50.3147 34.3421 50.3147 37.797C50.3147 41.743 47.1165 44.9412 43.1705 44.9412H22.631ZM27.0403 35.6202L31.5054 40.0854C32.03 40.61 32.8784 40.61 33.3975 40.0854L37.8626 35.6202C38.3872 35.0956 38.3872 34.2472 37.8626 33.7282C37.3379 33.2091 36.4896 33.2035 35.9705 33.7282L33.7938 35.9049V28.4202C33.7938 27.6779 33.1965 27.0807 32.4542 27.0807C31.7119 27.0807 31.1147 27.6779 31.1147 28.4202V35.9049L28.9379 33.7282C28.4133 33.2035 27.5649 33.2035 27.0458 33.7282C26.5268 34.2528 26.5212 35.1012 27.0458 35.6202H27.0403Z"
              fill={fillColor}
            />
          </g>
          <defs>
            <clipPath id="clip0_5551_149595">
              <rect
                width="35.7209"
                height="28.5767"
                fill="white"
                transform="translate(14.5938 18.1501)"
              />
            </clipPath>
          </defs>
        </>
      );
    case "spendremaing":
      return (
        <path
          d="M20.8112 20.4048H44.3112C46.1472 20.4048 47.6684 21.926 47.6684 23.7619V25.4405H17.4541V23.7619C17.4541 21.926 18.9229 20.4048 20.8112 20.4048ZM47.6684 30.4762V40.5476C47.6684 42.436 46.1472 43.9048 44.3112 43.9048H20.8112C18.9229 43.9048 17.4541 42.436 17.4541 40.5476V30.4762H47.6684ZM23.3291 37.1905C22.857 37.1905 22.4898 37.6101 22.4898 38.0298C22.4898 38.5019 22.857 38.8691 23.3291 38.8691H26.6862C27.1059 38.8691 27.5255 38.5019 27.5255 38.0298C27.5255 37.6101 27.1059 37.1905 26.6862 37.1905H23.3291ZM29.2041 38.0298C29.2041 38.5019 29.5713 38.8691 30.0434 38.8691H36.7577C37.1773 38.8691 37.597 38.5019 37.597 38.0298C37.597 37.6101 37.1773 37.1905 36.7577 37.1905H30.0434C29.5713 37.1905 29.2041 37.6101 29.2041 38.0298Z"
          fill={fillColor}
        />
      );

    case "setting":
      return (
        <>
          <path d="M17.4801 7.09097C17.8756 6.74004 18.0316 6.18858 17.8255 5.6984C17.6974 5.40317 17.5581 5.11352 17.4022 4.83501L17.2295 4.53421C17.0624 4.2557 16.8785 3.98275 16.6836 3.72095C16.3661 3.29761 15.8091 3.15835 15.3077 3.32546L13.7369 3.84349C13.1409 3.35331 12.4557 2.95225 11.7205 2.67931L11.3807 1.06392C11.2748 0.545888 10.8738 0.133687 10.3502 0.0724137C9.98254 0.0222811 9.60933 0 9.23055 0H9.19156C8.81278 0 8.43957 0.0222811 8.07193 0.0668434C7.54832 0.128116 7.14726 0.545888 7.04143 1.05835L6.70164 2.67931C5.96079 
          2.95782 5.28122 3.35331 4.6852 3.84349L3.10881 3.33103C2.60748 3.16392 2.05045 3.30318 1.73295 3.72652C1.53799 3.98832 1.35417 4.26127 1.18149 4.53978L1.01438 4.83501C0.858414 5.11352 0.719157 5.40317 0.591041 5.70397C0.38494 6.18858 0.540908 6.74004 0.936398 7.09654L2.173 8.19946C2.11173 8.57266 2.07831 8.96258 2.07831 9.35807C2.07831 9.75356 2.11173 10.1435 2.173 10.5223L0.936398 11.6252C0.540908 11.9761 0.38494 12.5276 0.591041 13.0177C0.719157 13.313 0.858414 13.6026 1.01438 13.8867L1.18149 14.1764C1.3486 14.4605 1.53242 14.7278 1.73295 14.9896C2.05045 15.413 2.60748 15.5522 3.10881 15.3851L4.67963 14.8671C5.27565 15.3573 5.96079 15.7583 6.69607 16.0313L7.03586 17.6522C7.14169 18.1703 7.54275 18.5825 8.06636 18.6437C8.43957 
          18.6883 8.81835 18.7106 9.2027 18.7106C9.58705 18.7106 9.96583 18.6883 10.339 18.6437C10.8626 18.5825 11.2637 18.1647 11.3695 17.6522L11.7093 16.0313C12.4502 15.7528 13.1297 15.3573 13.7258 14.8671L15.2966 15.3851C15.7979 15.5522 16.3549 15.413 16.6724 14.9896C16.8674 14.7278 17.0512 14.4605 17.2183 14.1764L17.391 13.8756C17.547 13.5971 17.6862 13.3074 17.8144 13.0122C18.0205 12.5276 17.8645 11.9761 17.469 11.6196L16.2324 10.5167C16.2937 10.1379 16.3271 9.74799 16.3271 9.3525C16.3271 8.95701 16.2937 8.56709 16.2324 8.18832L17.469 7.0854L17.4801 7.09097ZM6.53453 9.35807C6.53453 8.64896 6.81623 7.96888 7.31765 7.46746C7.81907 6.96603 8.49915 6.68434 9.20827 6.68434C9.91739 6.68434 10.5975 6.96603 11.0989 7.46746C11.6003 7.96888 11.882 8.64896 11.882 9.35807C11.882 10.0672 11.6003 10.7473 11.0989 11.2487C10.5975 11.7501 9.91739 12.0318 9.20827 12.0318C8.49915 12.0318 
          7.81907 11.7501 7.31765 11.2487C6.81623 10.7473 6.53453 10.0672 6.53453 9.35807ZM28.409 27.4336C28.76 27.8291 29.3114 27.9851 29.8016 27.779C30.0968 27.6509 30.3865 27.5116 30.665 27.3557L30.9658 27.183C31.2443 27.0159 31.5172 26.8321 31.7791 26.6371C32.2024 26.3196 32.3416 25.7626 32.1745 25.2612L31.6565 23.6904C32.1467 23.0944 32.5478 22.4092 32.8207 21.674L34.4416 21.3342C34.9597 21.2283 35.3719 20.8273 35.4332 20.3037C35.4777 19.9305 35.5 19.5517 35.5 19.1673C35.5 18.783 35.4777 18.4042 35.4332 18.031C35.3719 17.5074 34.9541 17.1063 34.4416 17.0005L32.8207 16.6551C32.5422 15.9143 32.1467 15.2347 31.6565 14.6387L32.1745 13.0679C32.3416 12.5666 32.2024 12.0095 31.7791 11.692C31.5172 11.4971 31.2443 11.3132 30.9658 11.1406L30.6706 10.9735C30.392 10.8175 30.1024 10.6782 29.8016 10.5501C29.317 10.344 28.7655 10.5 28.409 10.8955L27.3061 12.1321C26.9273 12.0708 26.5374 12.0374 26.1419 12.0374C25.7464 12.0374 25.3565 12.0708 24.9777 12.1321L23.8748 10.8955C23.5239 10.5 22.9724 10.344 22.4822 10.5501C22.187 10.6782 21.8974 10.8175 21.6133 10.9735L21.3236 11.1406C21.0395 11.3077 20.7722 11.4915 20.5104 11.692C20.087 12.0095 19.9478 12.5666 20.1149 13.0679L20.6329 14.6387C20.1427 15.2347 19.7417 15.9199 19.4687 16.6551L17.8478 16.9894C17.3297 17.0952 16.9175 17.4963 16.8563 18.0199C16.8117 18.3931 16.7894 18.7719 16.7894 19.1562C16.7894 19.5406 16.8117 19.9193 16.8563 20.2925C16.9175 
          20.8161 17.3353 21.2172 17.8478 21.323L19.4687 21.6628C19.7472 22.4037 20.1427 23.0833 20.6329 23.6793L20.1149 25.2501C19.9478 25.7514 20.087 26.3084 20.5104 26.6259C20.7722 26.8209 21.0395 27.0047 21.3236 27.1718L21.6244 27.3445C21.9029 27.5005 22.1926 27.6397 22.4878 27.7679C22.9724 27.974 23.5239 27.818 23.8804 27.4225L24.9833 26.1859C25.3621 26.2472 25.752 26.2806 26.1475 26.2806C26.543 26.2806 26.9329 26.2472 27.3117 26.1859L28.4146 27.4225L28.409 27.4336ZM26.1419 16.488C26.493 16.488 26.8407 16.5572 27.1651 16.6916C27.4895 16.8259 27.7843 17.0229 28.0325 17.2712C28.2808 17.5194 28.4778 17.8142 28.6121 18.1386C28.7465 18.463 28.8157 18.8107 28.8157 19.1618C28.8157 19.5129 28.7465 19.8606 28.6121 20.185C28.4778 20.5094 28.2808 20.8041 28.0325 21.0524C27.7843 21.3007 27.4895 21.4976 27.1651 21.632C26.8407 21.7663 26.493 21.8355 26.1419 21.8355C25.7908 21.8355 25.4431 21.7663 25.1187 21.632C24.7943 21.4976 24.4996 21.3007 24.2513 21.0524C24.003 20.8041 23.8061 20.5094 23.6717 20.185C23.5373 19.8606 23.4682 19.5129 23.4682 19.1618C23.4682 18.8107 23.5373 18.463 23.6717 18.1386C23.8061 17.8142 24.003 17.5194 24.2513 17.2712C24.4996 17.0229 24.7943 16.8259 25.1187 16.6916C25.4431 16.5572 25.7908 16.488 26.1419 16.488Z"
          transform="translate(15.674, 15.674)"
          fill={fillColor}/>


        </>
      );
     
    case "freeskiptraceremaining":
      return (
        <path d="M23.3136 20.5819C24.8334 18.4994 25.7356 15.9326 25.7356 13.1539C25.7356 6.1981 20.0984 0.562012 13.1412 0.562012C6.18406 0.562012 0.546875 6.1981 0.546875 13.1539C0.546875 20.1097 6.18406 25.7458 13.1412 25.7458C15.9205 25.7458 18.4878 24.8499 20.5707 23.3243L28.2363 30.9945C28.9932 31.7512 30.2223 31.7512 30.9792 30.9945C31.7361 30.2377 31.7361 29.0088 30.9792 28.2521L23.3136 20.5819ZM6.9913 19.2836C6.9913 16.8671 8.91389 14.8899 11.3858 14.8899H14.9014C17.3183 14.8899 19.2959 16.8671 19.2959 19.2836C19.2959 19.7779 18.8564 20.1623 18.417 20.1623H7.8702C7.37582 20.1623 6.9913 19.7779 6.9913 19.2836ZM11.3858 12.6931C10.2872 12.0341 9.62799 10.8808 9.62799 9.6176C9.62799 8.40935 10.2872 7.25603 11.3858 6.59698C12.4295 5.99286 13.8028 5.99286 14.9014 6.59698C15.9451 7.25603 16.6592 8.40935 16.6592 9.6176C16.6592 10.8808 15.9451 12.0341 14.9014 12.6931C13.8028 13.2973 12.4295 13.2973 11.3858 12.6931Z"
           transform="translate(15.674, 15.674)"
           fill={fillColor}/>
      );
  

    case "freeskiptraceremaining":
      return (
        <path d="M23.3136 20.5819C24.8334 18.4994 25.7356 15.9326 25.7356 13.1539C25.7356 6.1981 20.0984 0.562012 13.1412 0.562012C6.18406 0.562012 0.546875 6.1981 0.546875 13.1539C0.546875 20.1097 6.18406 25.7458 13.1412 25.7458C15.9205 25.7458 18.4878 24.8499 20.5707 23.3243L28.2363 30.9945C28.9932 31.7512 30.2223 31.7512 30.9792 30.9945C31.7361 30.2377 31.7361 29.0088 30.9792 28.2521L23.3136 20.5819ZM6.9913 19.2836C6.9913 16.8671 8.91389 14.8899 11.3858 14.8899H14.9014C17.3183 14.8899 19.2959 16.8671 19.2959 19.2836C19.2959 19.7779 18.8564 20.1623 18.417 20.1623H7.8702C7.37582 20.1623 6.9913 19.7779 6.9913 19.2836ZM11.3858 12.6931C10.2872 12.0341 9.62799 10.8808 9.62799 9.6176C9.62799 8.40935 10.2872 7.25603 11.3858 6.59698C12.4295 5.99286 13.8028 5.99286 14.9014 6.59698C15.9451 7.25603 16.6592 8.40935 16.6592 9.6176C16.6592 10.8808 15.9451 12.0341 14.9014 12.6931C13.8028 13.2973 12.4295 13.2973 11.3858 12.6931Z"
           transform="translate(15.674, 15.674)"
           fill={fillColor}/>
      );
    case "leadAutomatiornRemaining":
      return (
        <path d="M12.5947 0C19.5517 0.000167904 25.1884 5.63613 25.1885 12.5918C25.1885 15.3704 24.2863 17.937 22.7666 20.0195L30.4326 27.6904C31.1893 28.4472 31.1894 29.6759 30.4326 30.4326C29.6757 31.1893 28.4463 31.1893 27.6895 30.4326L20.0234 22.7627C17.9407 24.288 15.3737 25.1835 12.5947 25.1836C5.63752 25.1836 0 19.5476 0 12.5918C8.6047e-05 5.63602 5.63758 0 12.5947 0ZM12.583 5.85547C12.3964 5.85547 12.1827 5.88177 11.9961 6.06543L5.16211 11.9287C4.97556 12.1123 4.89554 12.3225 4.89551 12.5586C4.89551 13.0334 5.26833 13.4013 5.74805 13.4014H6.60352V15.2266C6.60085 15.2502 6.60156 15.2772 6.60156 15.3008V18.2393C6.60167 18.8189 7.07817 19.2878 7.66699 19.2881H8.09375C8.12559 19.2881 8.15761 19.2858 8.18945 19.2832C8.22935 19.2858 8.26968 19.2881 8.30957 19.2881H9.7998C10.3888 19.2881 10.8661 18.819 10.8662 18.2393V15.9307C10.8662 15.4664 11.2471 15.091 11.7188 15.0908H13.4248C13.8966 15.0908 14.2783 15.4663 14.2783 15.9307V18.2393C14.2784 18.819 14.7557 19.2881 15.3447 19.2881H16.8506C16.8877 19.2881 16.9248 19.2887 16.9619 19.2861C16.9911 19.2887 17.0206 19.2881 17.0498 19.2881H17.4766C18.0656 19.2881 18.5429 18.819 18.543 18.2393V17.8164C18.5509 17.7458 18.5566 17.6751 18.5566 17.6045L18.5381 13.4014H19.3906C19.8438 13.4014 20.2441 13.0309 20.2441 12.5586C20.2707 12.3225 20.1634 12.1123 19.9502 11.9287L13.1426 6.03906C12.9827 5.90793 12.7695 5.85551 12.583 5.85547Z" fill={fillColor} transform="translate(15.674, 15.674)"/>
      );
    case "callremaining":
      return (
        <path d="M10.0077 1.56326C9.51393 0.38201 8.22644 -0.24299 7.00144 0.0882603L6.65769 0.18201C2.62019 1.28201 -0.829814 5.19451 0.176436 9.95701C2.49519 20.8945 11.1014 29.5008 22.0389 31.8195C26.8077 32.832 30.7139 29.3758 31.8139 25.3383L31.9077 24.9945C32.2452 23.7633 31.6139 22.4758 30.4389 21.9883L24.3577 19.457C23.3264 19.0258 22.1327 19.3258 21.4202 20.1945L19.0077 23.1445C14.6139 20.9633 11.0764 17.3133 9.04519 12.832L11.8077 10.582C12.6764 9.87576 12.9702 8.68201 12.5452 7.64451L10.0077 1.56326Z" fill="#128292" fill={fillColor} transform="translate(15.674, 15.674)"/>
      );
    default:
      break;
  }
};

export const CircularProgress = ({
  percentage,
  type,
  radius = 32,
  strokeWidth = 8
}) => {
  const normalizedRadius = radius - strokeWidth * 0.5;
  const circumference = 2 * Math.PI * normalizedRadius;

  const strokeDasharray = `${circumference} ${circumference}`;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  // Ensure the percentage is between 0 and 100 and round it.
  const normalizedPercentage = Math.round(
    Math.max(0, Math.min(percentage, 100))
  );

  // Determine the color based on percentage.
  const fillColor = normalizedPercentage >= 20 ? "#128292" : "#CA1551"; // Teal or Rose color.

  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 65 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d={`M32.5 32
          m 0 -${normalizedRadius}
          a ${normalizedRadius} ${normalizedRadius} 0 1 1 0 ${normalizedRadius *
          2}
          a ${normalizedRadius} ${normalizedRadius} 0 1 1 0 -${normalizedRadius *
          2}`}
        stroke="#DFE1E4" // Set to light gray for the background
        strokeWidth={strokeWidth}
        fill="none" // No fill for the background path
      />

      {/* Progress Path */}
      <path
        d={`M32.5 32
          m 0 -${normalizedRadius}
          a ${normalizedRadius} ${normalizedRadius} 0 1 1 0 ${normalizedRadius *
          2}
          a ${normalizedRadius} ${normalizedRadius} 0 1 1 0 -${normalizedRadius *
          2}`}
          // L 32.5 32
        stroke={fillColor} // Set the stroke color for the progress
        strokeWidth={strokeWidth}
        strokeLinecap="round" // Add rounded corners for progress path
        strokeDasharray={strokeDasharray}
        strokeDashoffset={strokeDashoffset}
        fill="none" // No fill for the progress path
        style={{
          transition: "stroke-dashoffset 0.35s ease",
          transform: "rotate(0deg)", // Rotate to start from the top
          transformOrigin: "50% 50%"
        }}
      />
      {/* Existing SVG Paths */}
      {getIconsByType(type, fillColor)}
      {/* <path d="M22.4536 21.1161V44.1237C22.4536 44.8248 23.024 45.3952 23.7251 45.3952C23.9868 45.3952 24.2431 45.3167 24.4577 45.165L32.5001 39.5347L40.5426 45.165C40.7571 45.3167 41.0135 45.3952 41.2751 45.3952C41.9763 45.3952 42.5466 44.8248 42.5466 44.1237V21.1161C42.5466 19.7295 41.4216 18.6045 40.035 18.6045H24.9652C23.5786 18.6045 22.4536 19.7295 22.4536 21.1161Z" fill="#128292"/> */}
    </svg>
  );
};


export default withRouter(connect(null, {
  activateSubscriptionPopup: ActivateSubscriptionPopup.open,
  activateSubscriptionPopupClose: ActivateSubscriptionPopup.close,
  purchaseSavesAndExportsPopup: PurchaseSavesAndExportsPopup.open,
  purchaseSavesAndExportsPopupClose: PurchaseSavesAndExportsPopup.close
})(UsageSection));
